import { apiFetch, parseApiResponse } from '../../../utils/apiClient';

export const getNextcloudStatus = async () => {
  const response = await apiFetch('/api/ged/status');
  return parseApiResponse(response);
};

export const getNextcloudDocuments = async (path) => {
  const query = path ? `?path=${encodeURIComponent(path)}` : '';
  const response = await apiFetch(`/api/ged/documents${query}`);
  return parseApiResponse(response);
};

export const getNextcloudAccount = async () => {
  const response = await apiFetch('/api/ged/account');
  return parseApiResponse(response);
};

export const updateNextcloudAccount = async (payload) => {
  const response = await apiFetch('/api/ged/account', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

  return parseApiResponse(response);
};

export const testNextcloudAccount = async (payload) => {
  const response = await apiFetch('/api/ged/account/test', {
    method: 'POST',
    body: JSON.stringify(payload),
  });

  return parseApiResponse(response);
};

export const generateProjectGed = async (projectId) => {
  const response = await apiFetch(`/api/ged/projects/${projectId}/generate`, { method: 'POST' });
  return parseApiResponse(response);
};
